var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-banner-btn",on:{"click":_vm.showModal}},[_c('span',[_vm._v("免费体验")]),_c('icon',{staticClass:"icon",attrs:{"iconClass":"icongengduo-white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }